// Remembers the subscription plan a logged-out visitor chose, so it survives
// register -> verify email -> sign in, and can be added to the cart once the
// user is authenticated (checkout needs their subscription status first).
const KEY = 'pendingPlan'
const MAX_AGE_MS = 24 * 60 * 60 * 1000

function read() {
  try {
    let saved = JSON.parse(localStorage.getItem(KEY))
    if (!saved || Date.now() - saved.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(KEY)
      return null
    }
    return saved
  } catch (e) {
    return null
  }
}

export const pendingPlan = {
  save: (product, durationType) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ product, durationType, savedAt: Date.now() }),
      )
    } catch (e) {
      // storage blocked; the user will just have to pick the plan again
    }
  },

  // returns { product, durationType } or null
  get: () => read(),

  clear: () => {
    try {
      localStorage.removeItem(KEY)
    } catch (e) {
      // ignore
    }
  },
}

// Same idea for the email typed at registration, so the verification screen
// can prefill it. Session-only, and never put in the URL (GA records URLs).
const EMAIL_KEY = 'pendingVerifyEmail'

export const pendingEmail = {
  save: (email) => {
    try {
      sessionStorage.setItem(EMAIL_KEY, email)
    } catch (e) {
      // ignore
    }
  },
  get: () => {
    try {
      return sessionStorage.getItem(EMAIL_KEY) || ''
    } catch (e) {
      return ''
    }
  },
  clear: () => {
    try {
      sessionStorage.removeItem(EMAIL_KEY)
    } catch (e) {
      // ignore
    }
  },
}
